import type { TextButtons, ToolbarSettings, ToolbarSettingsFunctions } from 'ricos-types';
import { INSERT_PLUGIN_BUTTONS } from 'wix-rich-content-editor-common';

import { desktopTextButtonList, mobileTextButtonList } from './defaultTextFormattingButtons';
import { getDefaultToolbarSettings } from './getDefaultToolbarSettings';
import { mergeToolbarSettings } from './mergeToolbarSettings';

export function initToolbarSettings(toolbarSettings: ToolbarSettings): ToolbarSettingsFunctions[] {
  const textButtons: TextButtons = {
    mobile: mobileTextButtonList,
    desktop: desktopTextButtonList,
  };
  const pluginButtonNames = Object.values(INSERT_PLUGIN_BUTTONS);
  const defaultSettings = getDefaultToolbarSettings({ textButtons, pluginButtonNames });
  if (!toolbarSettings?.getToolbarSettings) {
    return defaultSettings;
  }

  const customSettings = toolbarSettings.getToolbarSettings({
    textButtons,
    pluginButtonNames,
  });

  return mergeToolbarSettings({ defaultSettings, customSettings });
}
